import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import PageHeader from '@/components/feature/PageHeader';
import useSEO from '@/hooks/useSEO';
import { siteInfo } from '@/lib/content';

const sections = [
  {
    icon: 'ri-focus-3-line',
    title: '网站定位',
    body: '本站是一个专注单部剧集《我的朋友他的妻子》的资料站。它不追求资讯的数量，而是把一部剧的剧情线、人物档案和幕后资料整理成可以顺着读的结构，让第一次接触的观众能快速进入，也让反复回看的观众找到细节。',
  },
  {
    icon: 'ri-layout-masonry-line',
    title: '内容如何组织',
    body: '剧情按"幕"拆分，每一幕标注播出集数、关键场景与人物关系的位移；演员页按姓名索引，记录角色设定和演员的创作思路；资讯页按发布时间倒序，收录剧评、专访与制作揭秘。三类内容通过标签互相连接，详情页底部会基于标签给出相关推荐。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '使用说明',
    body: '站内所有内容均可免费阅读，文字支持选中复制。搜索为前端检索，结果即时展示并高亮关键词。分类页支持排序、筛选与分页，筛选条件变化时会自动回到第一页。若链接中的内容编号不存在，页面会提示"内容不存在"并提供返回入口。',
  },
];

export default function AboutPage() {
  useSEO({
    title: '关于本站与版权声明 - 我的朋友他的妻子',
    description:
      '了解《我的朋友他的妻子》影视资料站的定位、内容组织方式、使用说明与版权声明。本站为虚构内容演示站点，不提供播放、下载或用户登录功能。',
    keywords: '关于本站,版权声明,使用说明,我的朋友他的妻子',
  });

  return (
    <SiteLayout>
      <PageHeader
        eyebrow="ABOUT"
        title="关于本站"
        description="一个为单部剧集建立的内容档案库。我们把剧情、人物与幕后资料放在同一个结构里，让阅读这部剧的方式不止一种。"
        crumbs={[{ label: '首页', to: '/' }, { label: '关于' }]}
      />

      <section className="w-full px-4 py-10 md:px-8 md:py-16 lg:px-12">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
          <div className="space-y-5">
            {sections.map((section) => (
              <div
                key={section.title}
                className="rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/70 text-primary-400">
                    <i className={`${section.icon} text-base`}></i>
                  </span>
                  <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {section.title}
                  </h2>
                </div>
                <p className="mt-3 text-sm leading-loose text-foreground-400">{section.body}</p>
              </div>
            ))}

            <div className="rounded-lg border border-primary-500/25 bg-primary-950/30 p-5 md:p-6">
              <h2 className="flex items-center gap-2 font-heading text-base font-bold text-primary-200">
                <i className="ri-mail-line"></i>
                联系方式
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-400">
                内容纠错、资料补充或合作咨询，可通过以下邮箱联系我们。为保护隐私，本站不设在线留言表单，请直接通过邮件沟通。
              </p>
              <a
                href={`mailto:${siteInfo.email}`}
                className="mt-4 inline-flex max-w-full items-center gap-2 rounded-md border border-primary-500/40 px-4 py-2 text-sm text-primary-300 transition-colors hover:bg-primary-500/10"
              >
                <i className="ri-mail-send-line shrink-0"></i>
                <span className="break-all">{siteInfo.email}</span>
              </a>
              <p className="mt-3 text-xs text-foreground-600">
                邮箱为演示用示例地址，不接收真实投稿。
              </p>
            </div>
          </div>

          <aside className="space-y-5">
            <div className="rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6">
              <h2 className="font-heading text-base font-bold text-foreground-950">剧集资料</h2>
              <dl className="mt-4 space-y-3 text-sm">
                {[
                  { label: '剧集名称', value: '我的朋友他的妻子' },
                  { label: '类型', value: '都市情感 · 悬疑' },
                  { label: '集数', value: '共 12 集' },
                  { label: '首播年份', value: '2025' },
                  { label: '主要场景', value: '旧城酒吧 / 公寓 / 南岸海边' },
                  { label: '内容形态', value: '剧情介绍、演员档案、幕后资讯' },
                ].map((row) => (
                  <div
                    key={row.label}
                    className="flex items-start justify-between gap-4 border-b border-background-200/60 pb-2.5 last:border-0 last:pb-0"
                  >
                    <dt className="shrink-0 text-xs text-foreground-600">{row.label}</dt>
                    <dd className="text-right text-sm text-foreground-300">{row.value}</dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className="rounded-lg border border-secondary-700/40 bg-secondary-900 p-5 md:p-6">
              <h2 className="font-heading text-base font-bold text-foreground-950">版权声明</h2>
              <p className="mt-3 text-sm leading-loose text-foreground-400">
                本站为影视内容展示类演示站点。站内出现的剧名、人物、剧情、演员姓名、报道文本与图片均为虚构示例或示意素材，不对应任何真实作品与真实人物，也不涉及真实评分、票房或奖项信息。
              </p>
              <p className="mt-3 text-sm leading-loose text-foreground-500">
                本站不提供视频播放、下载、用户注册、登录、收藏或评论功能。任何页面均不会展示虚假的操作成功状态。
              </p>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6">
              <h2 className="font-heading text-base font-bold text-foreground-950">快速入口</h2>
              <div className="mt-4 flex flex-col gap-2.5">
                {[
                  { label: '剧情介绍', to: '/story' },
                  { label: '演员详情', to: '/cast' },
                  { label: '影视资讯', to: '/news' },
                  { label: '站内搜索', to: '/search' },
                ].map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="flex items-center justify-between rounded-md border border-background-200/70 px-3 py-2.5 text-sm text-foreground-300 transition-colors hover:border-primary-500/40 hover:text-primary-300"
                  >
                    {link.label}
                    <i className="ri-arrow-right-s-line"></i>
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>
    </SiteLayout>
  );
}